import { render, staticRenderFns } from "./WelfareMallPlaneTicketOrder.vue?vue&type=template&id=546ae408&scoped=true"
import script from "./WelfareMallPlaneTicketOrder.vue?vue&type=script&lang=js"
export * from "./WelfareMallPlaneTicketOrder.vue?vue&type=script&lang=js"
import style0 from "./WelfareMallPlaneTicketOrder.vue?vue&type=style&index=0&id=546ae408&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546ae408",
  null
  
)

export default component.exports